import { OFFLINE_WARM_BUILD_KEY } from '@module/mdrt-org/shared/utils/constants/business-critical-cache';

const getBuildFingerprint = () =>
  [...document.querySelectorAll<HTMLScriptElement>('script[src*="/_next/static/"]')].map(
    (script) => script.src
  );

const readLastWarmedBuild = () => {
  try {
    return JSON.parse(localStorage.getItem(OFFLINE_WARM_BUILD_KEY) ?? 'null') as null | string[];
  } catch {
    return null;
  }
};

export const isSameBuildAsLastPass = () => {
  const previous = readLastWarmedBuild();

  if (!previous) {
    return false;
  }

  const seen = new Set(previous);
  const current = new Set(getBuildFingerprint());

  return seen.size === current.size && [...current].every((url) => seen.has(url));
};

export const rememberWarmedBuild = () => {
  try {
    localStorage.setItem(OFFLINE_WARM_BUILD_KEY, JSON.stringify(getBuildFingerprint()));
  } catch {
    // Storage can be unavailable or full — the next launch then simply re-warms everything.
  }
};
